/**
 * PostHog consent sync — Shopify's Customer Privacy API decides whether
 * PostHog captures.
 *
 * PostHog boots opted out and storage-less (snippets/posthog.liquid).
 * Once Shopify reports analytics processing is allowed we opt in; a later
 * withdrawal opts back out, which also clears PostHog's cookie and storage.
 * Outside consent regions the API allows everything, so this is a no-op
 * there. If the API never loads we stay opted out: no consent signal, no
 * capture. Shopify's banner only governs Shopify's own tools, so a theme
 * script has to do this itself.
 *
 * Calls made before array.js has loaded are queued by PostHog's stub and
 * replayed on load, so there is no readiness check on the PostHog side.
 */

const mbPostHogSyncConsent = (privacy) => {
  const posthog = window.posthog;
  if (!posthog) return;
  let allowed = false;
  try {
    allowed = privacy.analyticsProcessingAllowed();
  } catch {
    allowed = false;
  }
  if (allowed) {
    // No `$opt_in` event: the consent action belongs to Shopify's banner.
    posthog.opt_in_capturing({ captureEventName: null });
    posthog.set_config({ disable_session_recording: false });
  } else {
    posthog.opt_out_capturing();
    // opt_out_capturing blocks sending but leaves the recorder observing; this stops it.
    posthog.set_config({ disable_session_recording: true });
  }
};

const mbWithCustomerPrivacy = (callback) => {
  if (window.Shopify?.customerPrivacy) {
    callback(window.Shopify.customerPrivacy);
    return;
  }
  if (typeof window.Shopify?.loadFeatures !== 'function') return;
  // Only v0.1 of the bundle exists on this storefront; 0.2 errors out.
  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    (error) => {
      if (error || !window.Shopify.customerPrivacy) return;
      callback(window.Shopify.customerPrivacy);
    }
  );
};

mbWithCustomerPrivacy((privacy) => {
  mbPostHogSyncConsent(privacy);
  document.addEventListener('visitorConsentCollected', () => mbPostHogSyncConsent(privacy));
});
